var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"spec-map",staticClass:"map"},[_c('div',{staticClass:"custom-control"},[_c('a',{on:{"click":function($event){return _vm.toggle3d()}}},[_c('img',{attrs:{"src":require("@/assets/icons/td.svg"),"alt":""}})])]),_vm._v(" "),_c('app-map-label',{attrs:{"labels":{available: false, sold: false, favorites: false, spec: true}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cba6541","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/journey/spec/SpecMap.vue
// module id = 284
// module chunks = 0